import { oktaConfig as okta } from './okta.config.development';

export const environment = {
  production: false,
  apiUrl: 'https://dntiop-vendorapiuat.cbre.com/api/v1',
  fileUploadApiUrl: 'https://dntiop-sharedapiuat.cbre.com/api/v1',
  iskillApiUrl: 'https://iskill-uat.cbre.com/api/v1/iskill',
  okta,
  // Signal in-app feedback widget (UAT stack). The host app is registered as 'iop' in the Signal UAT admin.
  signal: {
    scriptUrl: 'https://signal-uat.cbre.com/signal/v1/signal.js',
    apiBase: 'https://signalapi-uat.cbre.com',
    appKey: 'iop',
    env: 'uat',
  },
};
